import React, { Component } from 'react';
import Input from '../../components/UI/Input/Input';
import Card from '@material-ui/core/Card';
import classes from './../../index.css';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Aux from '../../hoc/Aux';
import axios from '../../axios-ns';
import * as messages from '../../messages';
import EmailIcon from "@material-ui/icons/EmailOutlined";

class SendPasswordResetMail extends Component {
    state = {
        isSent: false,
        loading: false,
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: messages.YOUR_EMAIL
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            }
        }
    };

    checkValidity(value, rules) {
        let isValid = true;

        if (!rules) {
            return true;
        }

        if (rules.required) {
            isValid = value.trim() !== '' && isValid;
        }

        if (rules.minLength) {
            isValid = value.length >= rules.minLength && isValid;
        }

        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }

        return isValid;
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = {
            ...this.state.controls,
            [controlName]: {
                ...this.state.controls[controlName],
                value: event.target.value,
                valid: this.checkValidity(event.target.value, this.state.controls[controlName.validation]),
                touched: true
            }
        };
        this.setState({ controls: updatedControls });
    }

    submitHandler = (event) => {
        event.preventDefault();
        this.sendPasswordResetMail(this.state.controls.email.value);
    }

    sendPasswordResetMail = (email) => {
        this.setState({ ...this.state, loading: true });
        const resetData = {
            email: email,
        }

        let url = 'send-reset-password-mail';

        axios.post(url, resetData)
            .then(response => {
                this.setState({ ...this.state, isSent: true, loading: false });
            })
            .catch(err => {
                console.log("Coś poszło nie tak");
                this.setState({ ...this.state, isSent: true, loading: false });
            });
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }

        let form = formElementsArray.map(
            formElement => (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    changed={(event) => this.inputChangedHandler(event, formElement.id)}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    touched={formElement.config.touched}
                    value={formElement.config.value} />
            )
        );

        let errorMessage = null;

        if (this.state.error) {
            errorMessage = (
                <p style={{ color: '#f50057' }}>{this.state.error}</p>
            )
        }

        let view = <Spinner />;
        if (this.state.isSent) {
            view = <Card className={classes.Form}>
                <CardHeader title={messages.PASSWORD_RESET_MAIL_SENT_HEADER} className={classes.Head} />
                <EmailIcon fontSize="large" style={{fontSize: '70px', marginTop: '35px'}}/>
                <p>{messages.PASSWORD_RESET_EMAIL_SENT}</p>
            </Card>

        } else {
            view = (<Card className={classes.Form}>
                <CardHeader title={messages.RESET_PASSWORD} className={classes.Head} />
                {errorMessage}
                <form onSubmit={this.submitHandler}>
                    <p>{messages.RESET_PASSWORD_PROCEDURE}</p>
                    {form}
                    <Button color="primary" variant="outlined" type="submit" style={{ marginBottom: '35px' }}>
                        {messages.RESET_PASSWORD}
                    </Button>
                </form>
            </Card>
            );
        }

        if (this.state.loading) {
            view = <Spinner />;
        }

        return (
            <Aux>
                {view}
            </Aux>
        )
    }
}

export default SendPasswordResetMail; 